import moment from 'moment';

export default function(invoice, now)
{
    const p = moment(`${invoice.quarter} ${invoice.year}`, 'Q YYYY').add(2, 'quarter');

    return moment(now).diff(p, 'days');
}